// frontend/src/session/graceful-exit.ts
import type { GuardedForm } from '../contexts/SessionGuardContext';
import * as authApi from '../services/authApi';

export async function gracefulExit(
  forms: GuardedForm[],
  deps?: { logout?: () => Promise<void>; redirect?: (to: string) => void },
): Promise<void> {
  const logout = deps?.logout ?? authApi.logout;
  const redirect = deps?.redirect ?? ((to: string) => { window.location.href = to; });

  for (const f of forms) {
    let dirty = false;
    try { dirty = f.isDirty(); } catch { dirty = false; }
    if (!dirty) continue;
    try {
      if (f.validateAndSave) {
        const res = await f.validateAndSave();
        if (!res?.saved) f.stash();
      } else {
        f.stash();
      }
    } catch {
      try { f.stash(); } catch { /* ignore */ }
    }
  }

  try { await logout(); } catch { /* local sign-out is authoritative */ }
  sessionStorage.setItem('cnf_session_ended', '1');
  redirect('/login');
}

let sink: (() => void) | null = null;
let firing = false;
export function setSessionEndSink(fn: () => void): void { sink = fn; }
export function triggerSessionEnd(): boolean {
  if (firing || !sink) return false;
  firing = true;
  sink();
  return true;
}
